"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClientSide = exports.default = void 0;
var isClientSide = function isClientSide() {
  return typeof window !== 'undefined';
};
exports.isClientSide = isClientSide;
var _default = {
  isClientSide: isClientSide
};
exports.default = _default;
//# sourceMappingURL=clientSide.js.map